module.exports = __webpack_public_path__ + "static/media/avc_blood_pressure.7e1f59ee.svg";